
import React from 'react';
import { Card } from '@/components/ui/card';
import { Circle } from 'lucide-react';

interface AvailabilityLegendProps {
  isVisible: boolean;
}

const AvailabilityLegend: React.FC<AvailabilityLegendProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="absolute bottom-4 right-4 z-40 animate-in fade-in-0 slide-in-from-right-2">
      <Card className="p-3 bg-white shadow-lg border border-gray-200">
        <h4 className="text-sm font-semibold mb-2 text-gray-700">Site Status</h4>
        <div className="space-y-2 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-green-500 flex items-center justify-center">
              <Circle className="w-2 h-2 fill-white text-white" />
            </div>
            <span className="text-gray-600">Available</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-red-500 flex items-center justify-center">
              <Circle className="w-2 h-2 fill-white text-white" />
            </div>
            <span className="text-gray-600">Currently Booked</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-orange-500 flex items-center justify-center">
              <Circle className="w-2 h-2 fill-white text-white" />
            </div>
            <span className="text-gray-600">Booked for Selected Dates</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default AvailabilityLegend;
